import CollectivityService from '@/services/CollectivityService';

const createStore = app => {
    const state = {
        allianties: {},
        zoekResultaten: [],
        pending: false,
        isApiUnavailable: true
    };

    const getters = {
        getAllianties: (state, _getters, _rootState, rootGetters) => {
            const taal = rootGetters['renderInfo/getTaal'] === 'nl' ? 'naam' : 'naamEn';
            if (!state.allianties) return;

            return Object.values(state.allianties).map(alliantie => alliantie[taal]);
        },
        getZoekResultaten: state => state.zoekResultaten,
        getPending: state => state.pending,
        getApiStatus: state => state.isApiUnavailable
    };

    const actions = {
        clearZoekResultaten({ commit }) {
            commit('CLEAR_ZOEK_RESULTATEN');
        },
        clearAllianties({ commit }) {
            commit('CLEAR_ALLIANTIES');
        },
        async checkApiStatus({ rootGetters, commit }) {
            commit('SET_API_UNAVAILABLE', false);
            commit('START_REQUEST');

            try {
                await CollectivityService.getCollectivities({
                    brand: rootGetters['renderInfo/getPropositie'],
                    searchterm: 'achmea'
                });
            } catch (error) {
                commit('SET_API_UNAVAILABLE', true);
            }

            commit('END_REQUEST');
        },
        async ophalenZoekResultaten({ rootGetters, commit, dispatch }, zoekterm) {
            commit('CLEAR_ZOEK_RESULTATEN');
            commit('START_REQUEST');

            try {
                const collectivitiesData = await CollectivityService.getCollectivities({
                    brand: rootGetters['renderInfo/getPropositie'],
                    searchterm: zoekterm
                });

                commit('SET_ZOEK_RESULTATEN', collectivitiesData);
            } catch (error) {
                dispatch('setComponentErrorStatus', { zoeker: true }, { root: true });
            }

            commit('END_REQUEST');
        },
        async ophalenAllianties({ rootGetters, commit, dispatch }) {
            commit('START_REQUEST');

            try {
                const alliancesData = await CollectivityService.getAlliances({
                    brand: rootGetters['renderInfo/getPropositie']
                });

                commit('SET_ALLIANTIES', alliancesData);
            } catch (error) {
                dispatch('setComponentErrorStatus', { allianties: true }, { root: true });
            }

            commit('END_REQUEST');
        },
        setAlliantieResultaten({ state, commit, rootGetters }, alliantieNaam) {
            const taal = rootGetters['renderInfo/getTaal'] === 'nl' ? 'naam' : 'naamEn';

            commit(
                'SET_ZOEK_RESULTATEN',
                Object.values(state.allianties).find(
                    allianties => allianties[taal] === alliantieNaam
                ).collectiviteiten
            );
        }
    };

    const mutations = {
        SET_ALLIANTIES(state, allianties) {
            state.allianties = { ...state.allianties, ...allianties };
        },
        SET_ZOEK_RESULTATEN(state, results) {
            state.zoekResultaten = results;
        },
        CLEAR_ZOEK_RESULTATEN(state) {
            state.zoekResultaten = [];
        },
        CLEAR_ALLIANTIES(state) {
            state.allianties = {};
        },
        SET_API_UNAVAILABLE(state, payload) {
            state.isApiUnavailable = payload;
        },
        START_REQUEST: state => {
            state.pending = true;
            state.error = false;
        },
        END_REQUEST: state => {
            state.pending = false;
        }
    };

    return {
        namespaced: true,
        state,
        getters,
        actions,
        mutations
    };
};

export const collectivitySearchStoragePaths = ['collectivity'];

export default app => createStore(app);
